import { render, staticRenderFns } from "./DeliveryAddressTable.component.vue?vue&type=template&id=afb1ebc2"
import script from "./DeliveryAddressTable.component.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressTable.component.vue?vue&type=script&lang=js"
import style0 from "./DeliveryAddressTable.component.vue?vue&type=style&index=0&id=afb1ebc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports